





















import Vue, { PropOptions } from 'vue';

export type Testimonial = Blok & {
  text: string;
  avatar: BlokFieldAsset;
  name: string;
  role: string;
  handle: string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Testimonial>,
  },
});
